import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const LINKED_JOBS_STALE_TIME = 5 * 60_000;

/** @registry CTC job list filtered by division names. */
export function useCtcList(divisions: readonly string[]) {
  return useQuery({
    queryKey: queryKeys.ctc.list(divisions),
    queryFn: ({ signal }) =>
      ctcApiClient.listCTCWithFilters(
        { divisions: [...divisions] },
        toCancelToken(signal),
      ),
    staleTime: 0,
    meta: { errorContext: 'CTC job list' },
  });
}

/** @registry GP job numbers that already have a Firetrol job linked to them. */
export function useCtcLinkedJobNumbers() {
  return useQuery({
    queryKey: queryKeys.ctc.linkedJobs(),
    queryFn: ({ signal }) => ctcApiClient.loadLinkedJobs(toCancelToken(signal)),
    staleTime: LINKED_JOBS_STALE_TIME,
    meta: { errorContext: 'CTC linked jobs' },
  });
}
